$(document).ready(function(){
  
  $('a.button').on('click', function(e){
    if(typeof $(this).data('pt_cta_id') != "undefined" && $(this).data('pt_cta_id') != "") {
      
      e.preventDefault();      
      const pt_cta_id = $(this).data('pt_cta_id');
      pSendGAEvent('pt_cta_click', { pt_cta_id: pt_cta_id}, 'industry.js', 'kirby industry page send event gone wrong');
      window.location = $(this).attr('href');
    }
        
  });
  
  $('.imageTextContainer img.clickable').on('click', function(){
    $(this).closest('.imageTextContainer').find('.fancybox').click();
  });
  
  
  $(window).on('resize', function() {
    
    var windowWidth = window.innerWidth;
    
    $('.rptoChooserContainer h2, .rptoChooserContainer p.discoverMore, .rptoChooserContainer p.justText, .rptoChooserContainer .buttonContainer, .efficiencyStories .story, .efficencyButton, .inputRow label.shl').css('height','auto');
    
    sameHeigtElement('.efficencyButton');
    sameHeigtElement('.inputRow label.shl');
    
    
    if(windowWidth > 991) {
      sameHeigtElement('.rptoChooserContainer h2');
      sameHeigtElement('.rptoChooserContainer p.discoverMore');
      sameHeigtElement('.rptoChooserContainer p.justText');
      sameHeigtElement('.rptoChooserContainer .listContainer');
      sameHeigtElement('.efficiencyStories .story');
    }
    
  });
  
  $(window).trigger('resize');  
  
  $('.imageTextContainer .paraLeft').each(function(index, obj){
    $(this).ptParalaxSideToCenter({side:'left', start:'-30vw', percentOfScreen: 50});
  });
  
  $('.imageTextContainer .paraRight').each(function(index, obj){
    $(this).ptParalaxSideToCenter({side:'right', start:'-30vw', percentOfScreen: 50});
  });  
  
  $('hr.containerMarker:not(.markerNeutral)').each(function(index, obj){
    $(this).ptParalaxRotate();
  });  
  
  
});

function sameHeigtElement(el) {
  
  $temp = 0;
  
  $(el).each(function(){
    if($(this).height() > $temp) {
      $temp = $(this).height();
    }
  });
  
  $(el).height($temp);
  
}

